import { lazy, type ComponentType } from "react";

type ModuleImport<T> = () => Promise<{ [key: string]: T }>;

export function lazyWithRetry<T extends ComponentType<unknown>>(
  importFn: ModuleImport<T>,
  exportName: string,
) {
  return lazy(() =>
    importFn()
      .then((module) => ({ default: module[exportName] as T }))
      .catch((error: unknown) => {
        const storageKey = `chunk-retry-${exportName}`;
        const hasRetried = sessionStorage.getItem(storageKey);

        if (!hasRetried) {
          sessionStorage.setItem(storageKey, "1");
          window.location.reload();
          return new Promise<never>(() => {});
        }

        sessionStorage.removeItem(storageKey);
        throw error;
      }),
  );
}
